import React from 'react';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Modal, Table } from 'antd';
import { useTheme } from 'styled-components';

const RolePermissions = ({ visible, onCancel }) => {
	const theme = useTheme();
	const hasRoleIcon = <CheckCircleOutlined style={{ fontSize: '22px', color: theme.TA_GREEN }} />;
	const missingRoleIcon = <CloseCircleOutlined style={{ fontSize: '22px', color: '#ff7875' }} />;

	let tableColumns: any = [
		{
			title: <span className="ps-4">Action</span>,
			dataIndex: 'action',
			key: 'action',
			render: (text, record) => <span className="ps-4">{text}</span>
		},
		{
			title: 'Admin',
			dataIndex: 'admin',
			key: 'admin',
			align: 'center',
			render: (text, record) => <span>{hasRoleIcon}</span>
		},
		{
			title: <span className="pe-4">User</span>,
			dataIndex: 'user',
			key: 'user',
			align: 'center',
			render: (text, record) => <span className="pe-4">{record.user ? hasRoleIcon : missingRoleIcon}</span>
		}
	];
	let permissionsData = [
		{
			key: '1',
			action: 'Send Offer',
			user: true
		},
		{
			key: '2',
			action: 'Offer Negotiation “Send Counteroffer, Accept, Reject“',
			user: true
		},

		{
			key: '3',
			action: 'Clone Job',
			user: true
		},
		{
			key: '4',
			action: 'Change Job Status “Close, On hold, Open“',
			user: true
		},
		{
			key: '5',
			action: 'View job board',
			user: true
		},
		{
			key: '6',
			action: 'Move Cards in the job board',
			user: true
		},
		{
			key: '7',
			action: 'Add interview slots',
			user: true
		},
		{
			key: '8',
			action: 'Cancel interview slot',
			user: true
		},
		{
			key: '9',
			action: 'Add Team members',
			user: false
		},
		{
			key: '10',
			action: 'Add Job',
			user: false
		},
		{
			key: '11',
			action: 'Edit Company Profile',
			user: false
		},
		{
			key: '12',
			action: 'Delete Team member account',
			user: false
		},
		{
			key: '13',
			action: 'Receive E-mail notification',
			user: false
		}
	];

	return (
		<Modal
			title="Role permissions"
			className="ta-modal"
			visible={visible}
			onCancel={onCancel}
			onOk={onCancel}
			width={700}
			style={{ top: '40px' }}
			bodyStyle={{
				boxSizing: 'border-box',
				overflow: 'auto',
				height: '78vh',
				padding: '24px 0'
			}}
		>
			<Table
				style={{ overflow: 'hidden' }}
				dataSource={permissionsData}
				columns={tableColumns}
				pagination={{ defaultPageSize: 20, hideOnSinglePage: true }}
			/>
		</Modal>
	);
};

export default RolePermissions;
